import { IS_BROWSER } from 'redux-bundler'

const checkTouch = () => {
  try {
    document.createEvent('TouchEvent')
    return true
  } catch (e) {
    return false
  }
}

const isTouch = IS_BROWSER && checkTouch()

export default isTouch

export const actionWord = isTouch ? 'tap' : 'click'
